module.exports = {"systemManage":{"oplogColumns":{"insertTime":"时间","doneAccount":"操作帐户","doWhat":"操作","moduleNameText":"模块","content":"详情"}}}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh.systemManage.json
// module id = G3We
// module chunks = 63 64